import { browserHelpers } from '../helpers/browser';

export * from './removeDropdownFocus';

const envSource = (browserHelpers.isBrowser() && window.ApprovalMax?.environment) || process.env.NODE_ENV || '';

export const isProd = ['production'].includes(envSource);
export const isStaging = ['staging', 'test'].includes(envSource);
export const isDev = ['development', 'local', 'debugweb', 'dev01', 'dev02', 'dev03', 'dev04', 'debug'].includes(
    envSource
);
export const isLocal = ['local', 'debugweb', 'debug'].includes(envSource);

export const salesEmail = 'sales@approvalmax.com';

export const extensions = {
    csv: { 'text/csv': ['.csv'] },
    pdf: { 'application/pdf': ['.pdf'] },
    xml: { 'application/xml': ['.xml'] },
    png: { 'image/png': ['.png'] },
    jpg: { 'image/jpg': ['.jpg', '.jpeg'] },
    gif: { 'image/gif': ['.gif'] },
    bmp: { 'image/bmp': ['.bmp'] },
    heif: { 'image/heif': ['.heif'] },
    postscript: { 'application/postscript': ['.eps', '.ai'] },
    numbers: { 'application/vnd.apple.numbers': ['.numbers'] },
    rtf: { 'application/rtf': ['.rtf'] },
    odt: { 'application/vnd.oasis.opendocument.text': ['.odt'] },
    ods: { 'application/vnd.oasis.opendocument.spreadsheet': ['.ods'] },
    odp: { 'application/vnd.oasis.opendocument.presentation': ['.odp'] },
    odf: { 'application/vnd.oasis.opendocument.formula': ['.odf'] },
    text: { 'text/plain': ['.txt', '.text'] },
    doc: { 'application/msword': ['.doc'] },
    docx: { 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'] },
    tiff: { 'image/tiff': ['.tif', '.tiff'] },
    eml: { 'message/rfc822': ['.eml'] },
    pages: { 'application/vnd.apple.pages': ['.pages'] },
    xls: { 'application/vnd.ms-excel': ['.xls'] },
    xlsx: { 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'] },
    ppt: { 'application/vnd.ms-powerpoint': ['.ppt'] },
    pptx: { 'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'] },
    zip: { 'application/zip': ['.zip'] },
    '7z': { 'application/x-7z-compressed': ['.7z'] },
    rar: { 'application/x-rar-compressed': ['.rar'] },
    keynote: { 'application/vnd.apple.keynote': ['.keynote', '.key'] },
    msg: { 'application/vnd.ms-outlook': ['.msg'] },
};

export const timezones = [
    {
        id: 'Dateline Standard Time',
        text: '(UTC-12:00) International Date Line West',
    },
    {
        id: 'UTC-11',
        text: '(UTC-11:00) Coordinated Universal Time-11',
    },
    {
        id: 'Aleutian Standard Time',
        text: '(UTC-10:00) Aleutian Islands',
    },
    {
        id: 'Hawaiian Standard Time',
        text: '(UTC-10:00) Hawaii',
    },
    {
        id: 'Marquesas Standard Time',
        text: '(UTC-09:30) Marquesas Islands',
    },
    {
        id: 'Alaskan Standard Time',
        text: '(UTC-09:00) Alaska',
    },
    {
        id: 'UTC-09',
        text: '(UTC-09:00) Coordinated Universal Time-09',
    },
    {
        id: 'Pacific Standard Time (Mexico)',
        text: '(UTC-08:00) Baja California',
    },
    {
        id: 'UTC-08',
        text: '(UTC-08:00) Coordinated Universal Time-08',
    },
    {
        id: 'Pacific Standard Time',
        text: '(UTC-08:00) Pacific Time (US & Canada)',
    },
    {
        id: 'US Mountain Standard Time',
        text: '(UTC-07:00) Arizona',
    },
    {
        id: 'Mountain Standard Time (Mexico)',
        text: '(UTC-07:00) La Paz, Mazatlan',
    },
    {
        id: 'Mountain Standard Time',
        text: '(UTC-07:00) Mountain Time (US & Canada)',
    },
    {
        id: 'Yukon Standard Time',
        text: '(UTC-07:00) Yukon',
    },
    {
        id: 'Central America Standard Time',
        text: '(UTC-06:00) Central America',
    },
    {
        id: 'Central Standard Time',
        text: '(UTC-06:00) Central Time (US & Canada)',
    },
    {
        id: 'Easter Island Standard Time',
        text: '(UTC-06:00) Easter Island',
    },
    {
        id: 'Central Standard Time (Mexico)',
        text: '(UTC-06:00) Guadalajara, Mexico City, Monterrey',
    },
    {
        id: 'Canada Central Standard Time',
        text: '(UTC-06:00) Saskatchewan',
    },
    {
        id: 'SA Pacific Standard Time',
        text: '(UTC-05:00) Bogota, Lima, Quito, Rio Branco',
    },
    {
        id: 'Eastern Standard Time (Mexico)',
        text: '(UTC-05:00) Chetumal',
    },
    {
        id: 'Eastern Standard Time',
        text: '(UTC-05:00) Eastern Time (US & Canada)',
    },
    {
        id: 'Haiti Standard Time',
        text: '(UTC-05:00) Haiti',
    },
    {
        id: 'Cuba Standard Time',
        text: '(UTC-05:00) Havana',
    },
    {
        id: 'US Eastern Standard Time',
        text: '(UTC-05:00) Indiana (East)',
    },
    {
        id: 'Turks And Caicos Standard Time',
        text: '(UTC-05:00) Turks and Caicos',
    },
    {
        id: 'Paraguay Standard Time',
        text: '(UTC-04:00) Asuncion',
    },
    {
        id: 'Atlantic Standard Time',
        text: '(UTC-04:00) Atlantic Time (Canada)',
    },
    {
        id: 'Venezuela Standard Time',
        text: '(UTC-04:00) Caracas',
    },
    {
        id: 'Central Brazilian Standard Time',
        text: '(UTC-04:00) Cuiaba',
    },
    {
        id: 'SA Western Standard Time',
        text: '(UTC-04:00) Georgetown, La Paz, Manaus, San Juan',
    },
    {
        id: 'Pacific SA Standard Time',
        text: '(UTC-04:00) Santiago',
    },
    {
        id: 'Newfoundland Standard Time',
        text: '(UTC-03:30) Newfoundland',
    },
    {
        id: 'Tocantins Standard Time',
        text: '(UTC-03:00) Araguaina',
    },
    {
        id: 'E. South America Standard Time',
        text: '(UTC-03:00) Brasilia',
    },
    {
        id: 'SA Eastern Standard Time',
        text: '(UTC-03:00) Cayenne, Fortaleza',
    },
    {
        id: 'Argentina Standard Time',
        text: '(UTC-03:00) City of Buenos Aires',
    },
    {
        id: 'Montevideo Standard Time',
        text: '(UTC-03:00) Montevideo',
    },
    {
        id: 'Magallanes Standard Time',
        text: '(UTC-03:00) Punta Arenas',
    },
    {
        id: 'Saint Pierre Standard Time',
        text: '(UTC-03:00) Saint Pierre and Miquelon',
    },
    {
        id: 'Bahia Standard Time',
        text: '(UTC-03:00) Salvador',
    },
    {
        id: 'UTC-02',
        text: '(UTC-02:00) Coordinated Universal Time-02',
    },
    {
        id: 'Greenland Standard Time',
        text: '(UTC-02:00) Greenland',
    },
    {
        id: 'Mid-Atlantic Standard Time',
        text: '(UTC-02:00) Mid-Atlantic - Old',
    },
    {
        id: 'Azores Standard Time',
        text: '(UTC-01:00) Azores',
    },
    {
        id: 'Cape Verde Standard Time',
        text: '(UTC-01:00) Cabo Verde Is.',
    },
    {
        id: 'UTC',
        text: '(UTC) Coordinated Universal Time',
    },
    {
        id: 'GMT Standard Time',
        text: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London',
    },
    {
        id: 'Greenwich Standard Time',
        text: '(UTC+00:00) Monrovia, Reykjavik',
    },
    {
        id: 'Sao Tome Standard Time',
        text: '(UTC+00:00) Sao Tome',
    },
    {
        id: 'Morocco Standard Time',
        text: '(UTC+01:00) Casablanca',
    },
    {
        id: 'W. Europe Standard Time',
        text: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    },
    {
        id: 'Central Europe Standard Time',
        text: '(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    },
    {
        id: 'Romance Standard Time',
        text: '(UTC+01:00) Brussels, Copenhagen, Madrid, Paris',
    },
    {
        id: 'Central European Standard Time',
        text: '(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb',
    },
    {
        id: 'W. Central Africa Standard Time',
        text: '(UTC+01:00) West Central Africa',
    },
    {
        id: 'GTB Standard Time',
        text: '(UTC+02:00) Athens, Bucharest',
    },
    {
        id: 'Middle East Standard Time',
        text: '(UTC+02:00) Beirut',
    },
    {
        id: 'Egypt Standard Time',
        text: '(UTC+02:00) Cairo',
    },
    {
        id: 'E. Europe Standard Time',
        text: '(UTC+02:00) Chisinau',
    },
    {
        id: 'West Bank Standard Time',
        text: '(UTC+02:00) Gaza, Hebron',
    },
    {
        id: 'South Africa Standard Time',
        text: '(UTC+02:00) Harare, Pretoria',
    },
    {
        id: 'FLE Standard Time',
        text: '(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius',
    },
    {
        id: 'Israel Standard Time',
        text: '(UTC+02:00) Jerusalem',
    },
    {
        id: 'South Sudan Standard Time',
        text: '(UTC+02:00) Juba',
    },
    {
        id: 'Kaliningrad Standard Time',
        text: '(UTC+02:00) Kaliningrad',
    },
    {
        id: 'Sudan Standard Time',
        text: '(UTC+02:00) Khartoum',
    },
    {
        id: 'Libya Standard Time',
        text: '(UTC+02:00) Tripoli',
    },
    {
        id: 'Namibia Standard Time',
        text: '(UTC+02:00) Windhoek',
    },
    {
        id: 'Jordan Standard Time',
        text: '(UTC+03:00) Amman',
    },
    {
        id: 'Arabic Standard Time',
        text: '(UTC+03:00) Baghdad',
    },
    {
        id: 'Syria Standard Time',
        text: '(UTC+03:00) Damascus',
    },
    {
        id: 'Turkey Standard Time',
        text: '(UTC+03:00) Istanbul',
    },
    {
        id: 'Arab Standard Time',
        text: '(UTC+03:00) Kuwait, Riyadh',
    },
    {
        id: 'Belarus Standard Time',
        text: '(UTC+03:00) Minsk',
    },
    {
        id: 'Russian Standard Time',
        text: '(UTC+03:00) Moscow, St. Petersburg',
    },
    {
        id: 'E. Africa Standard Time',
        text: '(UTC+03:00) Nairobi',
    },
    {
        id: 'Volgograd Standard Time',
        text: '(UTC+03:00) Volgograd',
    },
    {
        id: 'Iran Standard Time',
        text: '(UTC+03:30) Tehran',
    },
    {
        id: 'Arabian Standard Time',
        text: '(UTC+04:00) Abu Dhabi, Muscat',
    },
    {
        id: 'Astrakhan Standard Time',
        text: '(UTC+04:00) Astrakhan, Ulyanovsk',
    },
    {
        id: 'Azerbaijan Standard Time',
        text: '(UTC+04:00) Baku',
    },
    {
        id: 'Russia Time Zone 3',
        text: '(UTC+04:00) Izhevsk, Samara',
    },
    {
        id: 'Mauritius Standard Time',
        text: '(UTC+04:00) Port Louis',
    },
    {
        id: 'Saratov Standard Time',
        text: '(UTC+04:00) Saratov',
    },
    {
        id: 'Georgian Standard Time',
        text: '(UTC+04:00) Tbilisi',
    },
    {
        id: 'Caucasus Standard Time',
        text: '(UTC+04:00) Yerevan',
    },
    {
        id: 'Afghanistan Standard Time',
        text: '(UTC+04:30) Kabul',
    },
    {
        id: 'West Asia Standard Time',
        text: '(UTC+05:00) Ashgabat, Tashkent',
    },
    {
        id: 'Qyzylorda Standard Time',
        text: '(UTC+05:00) Astana',
    },
    {
        id: 'Ekaterinburg Standard Time',
        text: '(UTC+05:00) Ekaterinburg',
    },
    {
        id: 'Pakistan Standard Time',
        text: '(UTC+05:00) Islamabad, Karachi',
    },
    {
        id: 'India Standard Time',
        text: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi',
    },
    {
        id: 'Sri Lanka Standard Time',
        text: '(UTC+05:30) Sri Jayawardenepura',
    },
    {
        id: 'Nepal Standard Time',
        text: '(UTC+05:45) Kathmandu',
    },
    {
        id: 'Central Asia Standard Time',
        text: '(UTC+06:00) Bishkek',
    },
    {
        id: 'Bangladesh Standard Time',
        text: '(UTC+06:00) Dhaka',
    },
    {
        id: 'Omsk Standard Time',
        text: '(UTC+06:00) Omsk',
    },
    {
        id: 'Myanmar Standard Time',
        text: '(UTC+06:30) Yangon (Rangoon)',
    },
    {
        id: 'SE Asia Standard Time',
        text: '(UTC+07:00) Bangkok, Hanoi, Jakarta',
    },
    {
        id: 'Altai Standard Time',
        text: '(UTC+07:00) Barnaul, Gorno-Altaysk',
    },
    {
        id: 'W. Mongolia Standard Time',
        text: '(UTC+07:00) Hovd',
    },
    {
        id: 'North Asia Standard Time',
        text: '(UTC+07:00) Krasnoyarsk',
    },
    {
        id: 'N. Central Asia Standard Time',
        text: '(UTC+07:00) Novosibirsk',
    },
    {
        id: 'Tomsk Standard Time',
        text: '(UTC+07:00) Tomsk',
    },
    {
        id: 'China Standard Time',
        text: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi',
    },
    {
        id: 'North Asia East Standard Time',
        text: '(UTC+08:00) Irkutsk',
    },
    {
        id: 'Singapore Standard Time',
        text: '(UTC+08:00) Kuala Lumpur, Singapore',
    },
    {
        id: 'W. Australia Standard Time',
        text: '(UTC+08:00) Perth',
    },
    {
        id: 'Taipei Standard Time',
        text: '(UTC+08:00) Taipei',
    },
    {
        id: 'Ulaanbaatar Standard Time',
        text: '(UTC+08:00) Ulaanbaatar',
    },
    {
        id: 'Aus Central W. Standard Time',
        text: '(UTC+08:45) Eucla',
    },
    {
        id: 'Transbaikal Standard Time',
        text: '(UTC+09:00) Chita',
    },
    {
        id: 'Tokyo Standard Time',
        text: '(UTC+09:00) Osaka, Sapporo, Tokyo',
    },
    {
        id: 'North Korea Standard Time',
        text: '(UTC+09:00) Pyongyang',
    },
    {
        id: 'Korea Standard Time',
        text: '(UTC+09:00) Seoul',
    },
    {
        id: 'Yakutsk Standard Time',
        text: '(UTC+09:00) Yakutsk',
    },
    {
        id: 'Cen. Australia Standard Time',
        text: '(UTC+09:30) Adelaide',
    },
    {
        id: 'AUS Central Standard Time',
        text: '(UTC+09:30) Darwin',
    },
    {
        id: 'E. Australia Standard Time',
        text: '(UTC+10:00) Brisbane',
    },
    {
        id: 'AUS Eastern Standard Time',
        text: '(UTC+10:00) Canberra, Melbourne, Sydney',
    },
    {
        id: 'West Pacific Standard Time',
        text: '(UTC+10:00) Guam, Port Moresby',
    },
    {
        id: 'Tasmania Standard Time',
        text: '(UTC+10:00) Hobart',
    },
    {
        id: 'Vladivostok Standard Time',
        text: '(UTC+10:00) Vladivostok',
    },
    {
        id: 'Lord Howe Standard Time',
        text: '(UTC+10:30) Lord Howe Island',
    },
    {
        id: 'Bougainville Standard Time',
        text: '(UTC+11:00) Bougainville Island',
    },
    {
        id: 'Russia Time Zone 10',
        text: '(UTC+11:00) Chokurdakh',
    },
    {
        id: 'Magadan Standard Time',
        text: '(UTC+11:00) Magadan',
    },
    {
        id: 'Norfolk Standard Time',
        text: '(UTC+11:00) Norfolk Island',
    },
    {
        id: 'Sakhalin Standard Time',
        text: '(UTC+11:00) Sakhalin',
    },
    {
        id: 'Central Pacific Standard Time',
        text: '(UTC+11:00) Solomon Is., New Caledonia',
    },
    {
        id: 'Russia Time Zone 11',
        text: '(UTC+12:00) Anadyr, Petropavlovsk-Kamchatsky',
    },
    {
        id: 'New Zealand Standard Time',
        text: '(UTC+12:00) Auckland, Wellington',
    },
    {
        id: 'UTC+12',
        text: '(UTC+12:00) Coordinated Universal Time+12',
    },
    {
        id: 'Fiji Standard Time',
        text: '(UTC+12:00) Fiji',
    },
    {
        id: 'Kamchatka Standard Time',
        text: '(UTC+12:00) Petropavlovsk-Kamchatsky - Old',
    },
    {
        id: 'Chatham Islands Standard Time',
        text: '(UTC+12:45) Chatham Islands',
    },
    {
        id: 'UTC+13',
        text: '(UTC+13:00) Coordinated Universal Time+13',
    },
    {
        id: 'Tonga Standard Time',
        text: "(UTC+13:00) Nuku'alofa",
    },
    {
        id: 'Samoa Standard Time',
        text: '(UTC+13:00) Samoa',
    },
    {
        id: 'Line Islands Standard Time',
        text: '(UTC+14:00) Kiritimati Island',
    },
];
